<template>
  <div class="popovers">
    <div
      class="wrap"
      :style="'top:'+top+'px'"
      :class="{top:value.type}"
    >
      <div class="content-inner">
        <div
          v-if="value.title"
          class="ht hair-bottom"
        >
          <i />
          <span>{{ value.title }}</span>
          <a
            href="javascript:void(0)"
            @click="close"
          >X</a>
        </div>
        <div
          class="body"
          v-html="value.content"
        />
      </div>
    </div>
    <div
      class="arr"
      :class="{top:value.type}"
      :style="'top:'+value.pos.top+'px; left:'+value.pos.left+'px'"
    />
    <div
      class="mask"
      :style="'top:'+mask_top+'px; bottom:0'"
      @click="close"
    />
  </div>
</template>
<style lang="stylus">
.popovers
  // z-index 1100
  &.fadeInDown, &.fadeInOut
    transition all 0.3s cubic-bezier(0.55, 0, 0.1, 1)
  .arr
    position absolute
    display block
    left 30px
    width 16px
    height 16px
    margin-top -8px
    transform rotate(45deg)
    background #ffffff
    z-index 1300
    &.top
      background #f8f8f8
  .wrap
    position absolute
    left 50px
    right 80px
    z-index 1100
    .close
      position absolute
      right 30px
      top 30px
      opacity 0.5
      cursor pointer
      transition opacity 0.3s
      &:hover
        opacity 1
    .content-inner
      position relative
      border-radius 10px
      .ht
        padding 10px
        font-size 24px
        font-weight bold
        color #333
        background #f8f8f8
        border-radius 10px 10px 0 0
        display flex
        align-items center
        i
          display block
          flex-shrink 0
          width 5px
          height 16px
          background #f29739
          margin-right 10px
        span
          flex 1
        a
          padding 0 0.2rem
          font-weight normal
          color #999
          display block
      .body
        border-radius 0 0 10px 10px
        background #fff
        padding 20px 15px 20px
        color #555
        font-size 20px
        select
          border none
          border-bottom solid 1px #ccc
          appearance none
          -moz-appearance none
          -webkit-appearance none
          padding 3px 20px
          background none
          font-size 24px
          text-align center
          cursor pointer
          border-radius 0
        select::-ms-expand
          display none
        span
          margin-right 20px
          padding-left 5px
      .foot
        display block
        padding 10px 30px
        background #f7f7f7
        border-top 1px solid #ededed
        border-radius 0 0 6px 6px
        text-align center
        height 60px
        .btn
          box-shadow none
          padding 4px 45px
          margin 0 5px
          &.btn-cancel
            border 1px solid #ddd
            color #808080 !important
  .mask
    position absolute
    left 0
    right 0
    top 0
    height 250%
    z-index 1000
    background rgba(0, 0, 0, 0.5)
    &.fadeIn
      animation-duration 0.3s
    &.fadeOut
      animation-duration 0.3s
</style>

<script>
export default {
  props: {
    value: Object
  },
  data () {
    return {
      is_top: false,
      top: 0
    }
  },
  computed: {
    mask_top () {
      const h = document.documentElement.clientHeight - 160 || document.body.clientHeight - 160
      return this.value.type ? this.value.pos.top - h + 150 : this.value.pos.top - h
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.top = this.value.type ? this.value.pos.top : this.value.pos.top - $('.popovers .wrap').height() //eslint-disable-line
      this.arr_pos = { top: this.value.pos.top }
    })
  },
  methods: {
    close () {
      let value = this.value
      value.show = false
      this.$emit('input', value)
    }

  }

}
</script>
